export const gridHeader = {
    refNo: 'Reference No.',
    customerName: 'Customer Name',
    paymentAmount: 'Payment Amount',
    paymentDate: 'Payment Date',
    createdOn: 'Created On',
    createdBy: 'Created By',
    modifiedOn: 'Modified On',
    modifiedBy: 'Modified By',
    edit: 'Edit/Delete',
};